import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Icons } from '@/icons/icons'

// PROPS ============================================================================================================

export default /*#__PURE__*/_defineComponent({
  __name: 'LexonTooltipComponent',
  props: {
  position: {
    type: String as () => 'top' | 'left' | 'bottom' | 'right',
    default: 'right'
  },
  action: {
    type: Function,
    default: () => {}
  },
  icon: {
    type: String,
    default: Icons.INFO
  },
  message: {
    type: String,
    required: true
  },
  isWidthAuto: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;



// COMPUTED =========================================================================================================
const positionClass = computed(() => {
  switch (props.position) {
    case 'top':
      return `lexon-tooltip-component--top ${props.isWidthAuto ? 'width-auto' : ''}`
    default:
      return `lexon-tooltip-component ${props.isWidthAuto ? 'width-auto' : ''}`
  }
})

const tooltipPosition = computed(() => {
  switch (props.position) {
    case 'top':
      return { top: true }
    case 'bottom':
      return { bottom: true }
    case 'left':
      return { left: true }
    default:
      return { right: true }
  }
})

return { __sfc: true,props, positionClass, tooltipPosition }
}

})